import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

export default function NewsSection() {
  const items = (newsList as NewsItem[]).slice(0, 5);
  const [lead, ...rest] = items;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      {lead && (
        <Link
          to={`/detail/news/${lead.id}`}
          className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-50 cursor-pointer"
        >
          <div className="relative w-full h-56 md:h-64 overflow-hidden">
            <img
              src={lead.cover}
              alt={lead.title}
              title={`${lead.title} - 香蕉动漫`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-white">
              头条
            </span>
          </div>
          <div className="p-4 md:p-5">
            <h3 className="font-display font-bold text-base md:text-lg text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
              {lead.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{lead.summary}</p>
            <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                {lead.date}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                {lead.source}
              </span>
            </div>
          </div>
        </Link>
      )}

      <div className="flex flex-col gap-4">
        {rest.map((item) => (
          <Link
            key={item.id}
            to={`/detail/news/${item.id}`}
            className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="shrink-0 w-24 h-20 md:w-28 md:h-20 rounded-md overflow-hidden">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 香蕉动漫`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0 flex flex-col justify-center">
              <h3 className="font-medium text-sm md:text-base text-foreground-900 line-clamp-2 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                  {item.date}
                </span>
                <span className="hidden sm:inline-flex items-center gap-1">
                  <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center"></i>
                  {item.tags[0]}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}